import { message } from 'antd';
import { client } from '../../../actions';
import { userActions } from '../../../actions/user.actions';
import { authHeader } from '../../../helpers/auth-header';
import store from '../../../store';

const editFacility = async (
  formValues,
  editingFacility,
  descriptionAttachments,
  setNumberError
) => {
  try {
    const response = await client.put(
      `/RentPlace/rental_house`,
      {
        id: editingFacility.id,
        ...formValues,
        totalArea: String(formValues.totalArea)?.replace(/\,/, '.'),
        mopArea: String(formValues.mopArea)?.replace(/\,/, '.'),
        officesAmount: +formValues.officesAmount,
        broker: {
          id: +formValues.broker,
        },
        manager: {
          id: +formValues.manager,
        },
        description: {
          id: editingFacility.description?.id,
          description: formValues.description,
          attachments: descriptionAttachments,
        },
      },
      { headers: authHeader() }
    );
    if (response.data?.result && response.data.result === 'Error') {
      setNumberError(true);
      return;
    }
    return response;
  } catch (error) {
    if (error.response?.status === 401) {
      store.dispatch(userActions.logout());
      return;
    }
    console.error(error);
    message.error('При редактировании объекта произошла ошибка');
  }
};

export default editFacility;
